<template>
  <div>
    <!-- Показываем разделитель только если элемент не последний ИЛИ он развернут и имеет дочерние элементы -->
    <div v-if="!noDivider" class="divider" />
    <div v-else style="margin-bottom: 16px"></div>

    <div
        class="flex w-full division-content"
        :style="{ 'padding-left': `${depth * 22}px` }"
    >
      <div
          style="margin-right: 6px"
          @click="toggleExpand"
          class="cursor-pointer"
          :style="{ display: hasChildren ? 'block' : 'none' }"
      >
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="{ 'rotate-180': isExpanded }"
        >
          <path d="M5 7.5L10 12.5L15 7.5" stroke="#566A83" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="text">
        {{ data?.name }}
      </div>
      <div style="color: #566A83" class="ml-auto flex gap-3 division-content__icons">
        <Plus class="division-content__icon" @click="$emit('add', data)"/>
        <Pencil class="division-content__icon" @click="$emit('edit', data)"/>
        <Trash class="division-content__icon" @click="$emit('delete', data)"/>
      </div>
    </div>

    <!-- Рекурсивное отображение дочерних элементов -->
    <div v-if="isExpanded && hasChildren">
      <DivisionContent
          v-for="(child, index) in data.children"
          :key="child.id"
          :data="child"
          :depth="depth + 1"
          :expanded-items="expandedItems"
          :is-last="index === data.children.length - 1"
          :is-only="data.children.length === 1"
          @toggle-expand="handleToggleExpand"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
          @add="$emit('add', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import Pencil from "@/components/Icons/Pencil.vue";
import Plus from "@/components/Icons/Plus.vue";
import Trash from "@/components/Icons/Trash.vue";

const props = defineProps({
  data: Object,
  depth: {
    type: Number,
    default: 0
  },
  expandedItems: {
    type: Array,
    default: () => []
  },
  isLast: {
    type: Boolean,
    default: false
  },
  isOnly: {
    type: Boolean,
    default: false
  },
  noDivider: {
    type: Boolean,
  }
});

const emits = defineEmits(["edit", "delete", "add", "toggle-expand"]);

const hasChildren = computed(() =>
    props.data?.children && props.data.children.length > 0
);

const isExpanded = computed(() =>
    props.expandedItems.includes(props.data?.id)
);

const toggleExpand = () => {
  if (hasChildren.value) {
    emits('toggle-expand', props.data?.id);
  }
};

// Обработчик для рекурсивных вызовов от дочерних элементов
const handleToggleExpand = (itemId) => {
  emits('toggle-expand', itemId);
};

const showActions = ref(false);

const onOuterDropdownClick = function (e) {
  if (!e.target.closest(`.reasons-item__item_${props.data?.id}`)) {
    showActions.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", onOuterDropdownClick);
});

onUnmounted(() => {
  document.removeEventListener("click", onOuterDropdownClick);
});
</script>

<style scoped lang="scss">
.division-content {
  height: 32px;
  align-items: center;
  margin-bottom: 16px;

  &__icon {
    background-color: $light;
    padding: 2px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;

    &:hover {
      //background-color: darken($light, 10%);
    }
  }
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.cursor-pointer {
  cursor: pointer;
}
.divider {
  margin-bottom: 16px;
  margin-top: 16px;
  border-top: 1px solid $secondary-main;
}

.text {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
}
</style>